import React from 'react';
import SiteLogo from './SiteLogo';
import Tropicana from './Tropicana';
import Walmart from './Walmart';
import Publix from './Publix';

const Logo = props => {
  switch(props.name) {
    case "SiteLogo":
      return <SiteLogo {...props} />;
    case "Tropicana":
      return <Tropicana {...props} />;
    case "Walmart":
      return <Walmart {...props} />;
    case "Publix":
      return <Publix {...props} />;
    default:
      return <div />;
  }
}
export default Logo;
